import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { patientApi, patientErr } from "@/lib/patientApi";
import { ShoppingCart, SpinnerGap } from "@phosphor-icons/react";
import { loadSnap } from "@/lib/snap";
export { loadSnap };

// "Beli Sekarang" — patient-only one-time purchase via Midtrans Snap popup.
export const BuyRelaxButton = ({ itemType, itemId, priceLabel, testid = "relax-buy-now" }) => {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const poll = async (orderNo, tries = 20) => {
    for (let i = 0; i < tries; i++) {
      await new Promise((r) => setTimeout(r, 2000));
      try {
        const { data } = await patientApi.get(`/patient/relax/orders/${orderNo}`);
        if (data.status === "paid") { toast.success("Pembayaran berhasil! Materi ditambahkan ke Koleksi Saya."); nav("/koleksi-saya"); return; }
        if (["failed", "expired", "cancelled"].includes(data.status)) { toast.error("Pembayaran tidak selesai."); return; }
      } catch { /* keep polling */ }
    }
    toast.message("Menunggu konfirmasi pembayaran. Cek Koleksi Saya beberapa saat lagi.");
  };

  const buy = async () => {
    if (!localStorage.getItem("patient_token")) {
      toast.message("Silakan masuk sebagai pasien untuk membeli.");
      nav("/pasien/masuk");
      return;
    }
    setBusy(true);
    try {
      const { data } = await patientApi.post("/patient/relax/checkout", { item_type: itemType, item_id: itemId });
      await loadSnap(data.client_key, data.is_production);
      if (!window.snap) { toast.error("Gagal memuat Midtrans."); return; }
      window.snap.pay(data.snap_token, {
        onSuccess: () => poll(data.order_no),
        onPending: () => poll(data.order_no),
        onError: () => toast.error("Pembayaran gagal."),
        onClose: () => toast.message("Jendela pembayaran ditutup."),
      });
    } catch (err) {
      const status = err?.response?.status;
      if (status === 409) { toast.info(patientErr(err)); nav("/koleksi-saya"); }
      else if (status === 403) { toast.error("Email Anda belum diverifikasi."); }
      else toast.error(patientErr(err));
    } finally { setBusy(false); }
  };

  return (
    <button data-testid={testid} onClick={buy} disabled={busy}
      className="flex w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-[#F472B6] via-[#EC4899] to-[#DB2777] px-5 py-3.5 font-heading text-base font-extrabold text-white shadow-lg shadow-pink-200 transition-transform active:scale-[0.98] disabled:opacity-60">
      {busy ? <SpinnerGap size={20} weight="bold" className="animate-spin" /> : <ShoppingCart size={20} weight="fill" />}
      {busy ? "Memproses..." : `Beli Sekarang${priceLabel ? " · " + priceLabel : ""}`}
    </button>
  );
};
